"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.activateClickedItem = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
const activateClickedItem = (listData, index, subIndex) => {
  return listData === null || listData === void 0 ? void 0 : listData.map((m, i) => {
    if (i === index) {
      return (0, _extends2["default"])((0, _extends2["default"])({}, m), {
        items: m.items.map((n, k) => {
          if (k === subIndex) {
            return (0, _extends2["default"])((0, _extends2["default"])({}, n), {
              active: true
            });
          } else {
            return (0, _extends2["default"])((0, _extends2["default"])({}, n), {
              active: false
            });
          }
        })
      });
    }
    if (index >= 0) {
      return (0, _extends2["default"])((0, _extends2["default"])({}, m), {
        items: m.items.map(n => {
          return (0, _extends2["default"])((0, _extends2["default"])({}, n), {
            active: false
          });
        })
      });
    }
    return m;
  });
};
exports.activateClickedItem = activateClickedItem;